// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onboarding_register-container__tPJbw {
  padding: 32px;
  background-color: var(--primary-background-color);
  display: grid;
  grid-template-columns: 3fr 2fr;
}

.onboarding_register-content__2KBGx {
  padding: 0 48px 0 16px;
  display: grid;
  grid-template-rows: auto 1fr;
  gap: 8px;
}

.onboarding_content-header__zb7\\+i {
  display: grid;
  grid-template-columns: 1fr auto min-content;
  gap: 24px;
  align-items: center;
}

.onboarding_content-actions__6almz {
  display: flex;
  align-items: center;
  justify-content: center;
}

.onboarding_role-selection__rneBJ {
  display: grid;
  grid-template-rows: repeat(3, auto);
  max-width: 504px;
  min-width: 200px;
  gap: 32px;
}

.onboarding_role-header__PvXAl {
  display: grid;
  grid-template-rows: repeat(2, auto);
  gap: 8px;
}

.onboarding_role-choose__9YSfN {
  display: grid;
  gap: 12px;
}

.onboarding_role-back-cta__uTYLL {
  display: flex;
  justify-content: center;
}

@media (max-width: 980px) {
  .onboarding_register-container__tPJbw {
    padding: 24px;
    grid-template-columns: 1fr;
  }

  .onboarding_register-content__2KBGx {
    padding: 0;
  }

  .onboarding_content-header__zb7\\+i {
    grid-template-columns: 1fr auto;
    justify-content: space-between;
    gap: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/onboarding.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iDAAiD;EACjD,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,4BAA4B;EAC5B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE;IACE,aAAa;IACb,0BAA0B;EAC5B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,+BAA+B;IAC/B,8BAA8B;IAC9B,SAAS;EACX;AACF","sourcesContent":[".register-container {\n  padding: 32px;\n  background-color: var(--primary-background-color);\n  display: grid;\n  grid-template-columns: 3fr 2fr;\n}\n\n.register-content {\n  padding: 0 48px 0 16px;\n  display: grid;\n  grid-template-rows: auto 1fr;\n  gap: 8px;\n}\n\n.content-header {\n  display: grid;\n  grid-template-columns: 1fr auto min-content;\n  gap: 24px;\n  align-items: center;\n}\n\n.content-actions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.role-selection {\n  display: grid;\n  grid-template-rows: repeat(3, auto);\n  max-width: 504px;\n  min-width: 200px;\n  gap: 32px;\n}\n\n.role-header {\n  display: grid;\n  grid-template-rows: repeat(2, auto);\n  gap: 8px;\n}\n\n.role-choose {\n  display: grid;\n  gap: 12px;\n}\n\n.role-back-cta {\n  display: flex;\n  justify-content: center;\n}\n\n@media (max-width: 980px) {\n  .register-container {\n    padding: 24px;\n    grid-template-columns: 1fr;\n  }\n\n  .register-content {\n    padding: 0;\n  }\n\n  .content-header {\n    grid-template-columns: 1fr auto;\n    justify-content: space-between;\n    gap: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"register-container": `onboarding_register-container__tPJbw`,
	"register-content": `onboarding_register-content__2KBGx`,
	"content-header": `onboarding_content-header__zb7+i`,
	"content-actions": `onboarding_content-actions__6almz`,
	"role-selection": `onboarding_role-selection__rneBJ`,
	"role-header": `onboarding_role-header__PvXAl`,
	"role-choose": `onboarding_role-choose__9YSfN`,
	"role-back-cta": `onboarding_role-back-cta__uTYLL`
};
export default ___CSS_LOADER_EXPORT___;
